import { Injectable } from '@angular/core';
import { TokenPair } from '@kinet-open-network/shared/data-access/model';
import { AuthenticatedUser } from '../models/authenticated-user.model';

@Injectable({
  providedIn: 'root',
})
export class AuthStorageService {
  saveAccessToken(token: string) {
    localStorage.setItem('accessToken', token);
  }

  getAccessToken(): string | null {
    return localStorage.getItem('accessToken');
  }

  clearAccessToken() {
    localStorage.removeItem('accessToken');
  }

  saveRefreshToken(token: string) {
    localStorage.setItem('refreshToken', token);
  }

  getRefreshToken(): string | null {
    return localStorage.getItem('refreshToken');
  }

  clearRefreshToken() {
    localStorage.removeItem('refreshToken');
  }

  saveUser(user: AuthenticatedUser) {
    localStorage.setItem('user', JSON.stringify(user));
  }

  getUser(): AuthenticatedUser | null {
    const user = localStorage.getItem('user');

    if (!user) {
      return null;
    }

    return new AuthenticatedUser(JSON.parse(user));
  }

  clearUser() {
    localStorage.removeItem('user');
  }

  saveTokens(tokens: TokenPair) {
    this.saveAccessToken(tokens.accessToken);
    this.saveRefreshToken(tokens.refreshToken);
  }

  clearTokens() {
    this.clearAccessToken();
    this.clearRefreshToken();
  }

  clear() {
    this.clearTokens();
    this.clearUser();
  }
}
